import React from 'react';
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";


export default function ArgoDividerWithLabelHook(props) {

    const fileName = props.fileName;

    const label = props.label;

    const margin = props.margin ?? "0px"

    return (<Divider id={fileName + "-divider-ArgoDividerWithLabelHook"} style={{margin: margin}}>
        <Typography variant="subtitle1">
            {label}
        </Typography>
    </Divider>);
}


